/**
 * Protección de trabajo sin guardar. Cada formulario declara, mientras tiene cambios que
 * no llegaron al servidor, qué se perdería. La navegación interna pregunta antes de salir
 * y el navegador avisa al cerrar o recargar la pestaña. No guarda nada por su cuenta:
 * nunca se presenta como «guardado» algo que no lo está.
 */
import { useEffect, useId } from 'react'

const pendientes = new Map<string, string>()

function alDescargar(evento: BeforeUnloadEvent): void {
  if (pendientes.size === 0) return
  evento.preventDefault()
  evento.returnValue = ''
}

export function hayTrabajoSinGuardar(): string | null {
  const primero = pendientes.values().next()
  return primero.done ? null : primero.value
}

/** true si se puede salir: no hay trabajo pendiente o la persona confirma descartarlo. */
export function confirmarSalida(): boolean {
  const descripcion = hayTrabajoSinGuardar()
  if (!descripcion) return true
  const descartar = window.confirm(`${descripcion} no se ha guardado. ¿Salir y descartarlo?`)
  if (descartar) pendientes.clear()
  return descartar
}

export function useTrabajoSinGuardar(activo: boolean, descripcion: string): void {
  const id = useId()
  useEffect(() => {
    if (!activo) {
      pendientes.delete(id)
      return
    }
    pendientes.set(id, descripcion)
    window.addEventListener('beforeunload', alDescargar)
    return () => {
      pendientes.delete(id)
      if (pendientes.size === 0) window.removeEventListener('beforeunload', alDescargar)
    }
  }, [activo, descripcion, id])
}
